import { Box, Center } from '@chakra-ui/react'
import { useAuth } from '@hb/react'
import { PageContainer, SignInContent } from '@hb/react-web'
import { PracticeAssessmentsView } from './Assessments'

export const SignInPage = () => {
  const authUser = useAuth(s => s.authUser)
  if (authUser) {
    return <PracticeAssessmentsView />
  }
  return (
    <PageContainer>
      <Center w="100%">
        <Box w="100%" maxW="500px" bg="white">
          <SignInContent />
        </Box>
      </Center>
    </PageContainer>
  )
}
